import React from 'react';

export const EmptySquareIcon = ({ size = '1em' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="4" y="4" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const PixelZoomIcon = ({ size = '1em' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <text x="12" y="17" textAnchor="middle" fontFamily="sans-serif" fontSize="16" fontWeight="700" fill="currentColor">
      px
    </text>
  </svg>
);

export const FitToWindowIcon = ({ size = '1.5em' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M10 10 4 4m0 0h5m-5 0v5m10 1 6-6m0 0h-5m5 0v5M10 14l-6 6m0 0v-5m0 5h5m5-6 6 6m0 0h-5m5 0v-5" stroke="inherit" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
